/* sg-purchase.js - SafeGrip landing page behaviour. Progressive enhancement only. */
(function () {
  'use strict';

  function money(cents, fmt) {
    if (window.Shopify && Shopify.formatMoney) { try { return Shopify.formatMoney(cents, fmt); } catch (e) {} }
    return (cents / 100).toLocaleString('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr';
  }
  function emit(name, detail) { document.dispatchEvent(new CustomEvent(name, { detail: detail, bubbles: true })); }

  function findDrawer() {
    return document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, .drawer--cart');
  }

  /* Vilka sektioner temats varukorgslåda behöver för att kunna rita om sig.
     Debutify-lådan läser e.sections[id] i renderContents, så de måste med i POST:en. */
  function sectionIdsFor(drawer) {
    var ids = [];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        ids = drawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) { ids = []; }
    }
    if (!ids.length && window.Debutify && Debutify.cart_drawer_id) {
      ids = [Debutify.cart_drawer_id, 'cart-icon-bubble'];
    }
    return ids.filter(function (v, i, a) { return v && a.indexOf(v) === i; });
  }

  /* Temat rensar bara is-empty fran .drawer__inner. Klassen sitter aven pa
     <cart-drawer> och pa <body>, och da ligger tomt-laget kvar visuellt. */
  function clearEmptyState(drawer) {
    if (drawer) {
      drawer.classList.remove('is-empty');
      var inner = drawer.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
    document.body.classList.remove('empty-cart');
  }

  function openDrawer(drawer) {
    if (!drawer) return;
    if (typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
    drawer.classList.add('active', 'is-open');
  }

  /* Gemensam kop-logik for bade huvudknappen och den fasta mobilbaren. */
  function addToCart(form, ui) {
    ui = ui || {};
    var btn = ui.button || null;
    var errEl = ui.error || null;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var addUrl = (window.routes && window.routes.cart_add_url) || (root + 'cart/add.js');
    var cartUrl = (window.routes && window.routes.cart_url) || (root + 'cart');
    var drawer = findDrawer();
    var ids = sectionIdsFor(drawer);

    if (btn) btn.setAttribute('aria-busy', 'true');
    if (errEl) errEl.textContent = '';

    var body = new FormData(form);
    if (ids.length) {
      body.append('sections', ids.join(','));
      body.append('sections_url', window.location.pathname);
    }

    return fetch(addUrl, {
      method: 'POST',
      body: body,
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      })
      .then(function (item) {
        /* Reserv: om servern inte skickade med sektionerna, hamta dem separat
           i stallet for att oppna en tom lada. */
        if (item.sections || !ids.length) return item;
        return fetch(root + '?sections=' + encodeURIComponent(ids.join(',')))
          .then(function (r) { return r.json(); })
          .then(function (s) { item.sections = s; return item; })
          .catch(function () { return item; });
      })
      .then(function (item) {
        emit('sg:cart-add-success', { item: item });
        if (window.PUB_SUB_EVENTS && window.publish) {
          try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sg-purchase' }); } catch (e) {}
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        if (!drawer) { window.location.href = cartUrl; return; }

        var rendered = false;
        if (item.sections && typeof drawer.renderContents === 'function') {
          try { drawer.renderContents(item); rendered = true; } catch (e) { rendered = false; }
        }

        if (!rendered) {
          /* Hellre skicka kunden till varukorgssidan an att visa en lada
             som pastar att varukorgen ar tom. */
          window.location.href = cartUrl;
          return;
        }

        clearEmptyState(drawer);
        openDrawer(drawer);
      })
      .catch(function (j) {
        emit('sg:cart-add-error', { error: j });
        if (errEl) errEl.textContent = (j && (j.description || j.message)) || 'Något gick fel. Försök igen.';
      })
      .then(function () {
        if (btn) btn.removeAttribute('aria-busy');
      });
  }

  if (!customElements.get('sg-purchase')) {
    customElements.define('sg-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this._wired) return; this._wired = true;
        this.form = this.querySelector('form');
        this.idInput = this.querySelector('[data-sg-variant-id]');
        this.productId = this.dataset.productId;
        this.moneyFmt = this.dataset.moneyFormat || '';
        this.data = {};
        var src = this.querySelector('[data-sg-variants]');
        if (src) { try { this.data = JSON.parse(src.textContent); } catch (e) {} }
        this.onTier = this.onTier.bind(this);
        this.onThumb = this.onThumb.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.addEventListener('change', this.onTier);
        this.addEventListener('click', this.onThumb);
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        var checked = this.querySelector('[data-sg-tier]:checked');
        if (checked) this.select(checked.value);
      }
      disconnectedCallback() {
        this.removeEventListener('change', this.onTier);
        this.removeEventListener('click', this.onThumb);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        this._wired = false;
      }
      onTier(e) { if (e.target.matches('[data-sg-tier]')) this.select(e.target.value); }
      onThumb(e) {
        var b = e.target.closest('[data-sg-thumb]'); if (!b) return;
        e.preventDefault();
        var i = b.dataset.sgThumb;
        this.querySelectorAll('[data-sg-thumb]').forEach(function (t) { t.setAttribute('aria-current', t === b ? 'true' : 'false'); });
        this.querySelectorAll('[data-sg-slide]').forEach(function (s) { s.classList.toggle('is-active', s.dataset.sgSlide === i); });
      }
      select(id) {
        var v = this.data[id]; if (!v) return;
        if (this.idInput) this.idInput.value = id;
        var now = this.querySelector('[data-sg-price]');
        var was = this.querySelector('[data-sg-compare]');
        var save = this.querySelector('[data-sg-save]');
        var hasSale = v.compare_at && v.compare_at > v.price;
        if (now) now.textContent = money(v.price, this.moneyFmt);
        if (was) was.textContent = hasSale ? money(v.compare_at, this.moneyFmt) : '';
        if (save) save.textContent = hasSale ? (save.dataset.tpl || 'Du sparar [v]').replace('[v]', money(v.compare_at - v.price, this.moneyFmt)) : '';
        var btn = this.querySelector('[data-sg-submit]');
        if (btn) {
          var lbl = btn.querySelector('[data-sg-submit-label]') || btn;
          lbl.textContent = v.available
            ? (btn.dataset.tpl || 'Lägg i varukorgen').replace('[price]', money(v.price, this.moneyFmt))
            : (btn.dataset.soldout || 'Slutsåld');
          btn.disabled = !v.available;
        }
        if (v.media_index != null) {
          var t = this.querySelector('[data-sg-thumb="' + v.media_index + '"]');
          if (t) t.click();
        }
        emit('sg:variant-change', {
          productId: this.productId, variantId: id, price: v.price, compareAt: v.compare_at,
          formattedPrice: money(v.price, this.moneyFmt), available: v.available,
          label: v.title, sourceSectionId: this.dataset.sectionId
        });
      }
      onSubmit(e) {
        if (!window.fetch || !this.form) return;
        e.preventDefault();
        if (this._busy) return; this._busy = true;
        var self = this;
        addToCart(this.form, {
          button: this.querySelector('[data-sg-submit]'),
          error: this.querySelector('[data-sg-error]')
        }).then(function () { self._busy = false; });
      }
    });
  }

  if (!customElements.get('sg-sticky')) {
    customElements.define('sg-sticky', class extends HTMLElement {
      connectedCallback() {
        if (this._wired) return; this._wired = true;
        var self = this;
        this.bar = this.querySelector('[data-sg-bar]');
        this.productId = this.dataset.productId;
        this.form = this.querySelector('form');
        this.onVariant = this.onVariant.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        document.addEventListener('sg:variant-change', this.onVariant);
        /* Samma AJAX-flode som huvudknappen, sa mobilbaren inte laddar om sidan. */
        if (this.form) this.form.addEventListener('submit', this.onSubmit);
        var trigger = document.querySelector(this.dataset.trigger || '[data-sg-anchor]');
        if ('IntersectionObserver' in window && trigger && this.bar) {
          this.io = new IntersectionObserver(function (en) {
            var e0 = en[0];
            self.bar.classList.toggle('is-visible', !e0.isIntersecting && e0.boundingClientRect.top < 0);
          }, { threshold: 0 });
          this.io.observe(trigger);
        } else if (this.bar) { this.bar.classList.add('is-visible'); }
      }
      disconnectedCallback() {
        document.removeEventListener('sg:variant-change', this.onVariant);
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
        if (this.io) this.io.disconnect();
        this._wired = false;
      }
      onSubmit(e) {
        if (!window.fetch || !this.form) return;
        e.preventDefault();
        if (this._busy) return; this._busy = true;
        var self = this;
        addToCart(this.form, { button: this.querySelector('[data-sg-bar-btn]') })
          .then(function () { self._busy = false; });
      }
      onVariant(e) {
        var d = e.detail; if (!d || String(d.productId) !== String(this.productId)) return;
        var p = this.querySelector('[data-sg-bar-price]'); if (p) p.textContent = d.formattedPrice;
        var s = this.querySelector('[data-sg-bar-opt]'); if (s && d.label) s.textContent = d.label;
        var i = this.querySelector('[data-sg-bar-variant]'); if (i) i.value = d.variantId;
        var b = this.querySelector('[data-sg-bar-btn]');
        if (b) { b.disabled = !d.available; b.textContent = d.available ? (b.dataset.tpl || 'Lägg i varukorgen') : (b.dataset.soldout || 'Slutsåld'); }
      }
    });
  }

  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target.closest('details'); if (d) d.open = true;
    var th = e.target.querySelector('[data-sg-thumb]');
    if (th) th.click();
  });
})();